import React from 'react';

import Tooltip from 'core/components/Tooltip';
import * as Typo from 'core/styles/Typography';
import { isJssField, JssTextType } from 'core/utils/sitecore-utils';

import * as S from './Label.style';

interface IProps {
	htmlId?: string;
	label?: string | JssTextType;
	tooltip?: React.ReactNode;
	required?: boolean;
	readonly?: boolean;
	optionalText?: string;
	withoutTextWrap?: boolean;
	isLabelHidden?: boolean;
	margin?: string;
}

const Label = ({
	label,
	required,
	readonly,
	htmlId,
	tooltip,
	optionalText = ' (optional)',
	withoutTextWrap = false,
	isLabelHidden = false,
	margin,
}: IProps) => (
	<S.Label htmlFor={htmlId} className={isLabelHidden ? '-hidden' : ''}>
		<S.Content readonly={!!readonly} withoutTextWrap>
			{isJssField(label) ? (
				<Typo.RichText {...(margin && { margin })} jss={label as JssTextType} />
			) : (
				label
			)}
			<S.Optional>
				{readonly === false && required === false ? optionalText : null}
			</S.Optional>
		</S.Content>
		{!!tooltip && <Tooltip content={tooltip} />}
	</S.Label>
);

export default Label;
